







import {Vue, Component, Prop} from "vue-property-decorator";

@Component
export default class Ellipsifier extends Vue {
    @Prop({default: ""})
    maxWidth!: string;

    @Prop({default: "inline-block"})
    display!: string;

    get style() {
      if(this.maxWidth.length > 0) {
        return {
          maxWidth: this.maxWidth
        };
      }
      return {};
    }

    get classObj() {
      return {'block': this.display == "block", 'inline-block': this.display == "inline-block"}
    }
}
